// Etiqueta de ahorro vs precio de mostrador para cada tarifa del cotizador.
// Calcula la diferencia entre el precio de mostrador (rate.list_price) y el
// total_cost. Si el ahorro > 0, muestra "¡Ahorraste $XX.XX MXN vs precio de
// mostrador!" en verde junto al precio, con un ícono de compartir que abre
// WhatsApp (o la hoja de compartir nativa en móvil) con un texto listo.
import { Share2 } from "lucide-react";
import { formatMXN } from "@/lib/format";
import { getCarrier } from "@/lib/carriers";

const SHARE_URL = "https://bhgcnexuslogistics.com";

export function computeSavings(rate) {
  const list = Number(rate?.list_price) || 0;
  const total = Number(rate?.total_cost) || 0;
  if (list <= 0 || total <= 0) return 0;
  return Number((list - total).toFixed(2));
}

function buildShareText(rate, savings) {
  const c = getCarrier(rate.carrier);
  return [
    "🚚 ¡Ahorré con BHGC Nexus Logistics!",
    "",
    `Envié con ${c.name}${rate.service ? ` (${rate.service})` : ""} por solo ${formatMXN(rate.total_cost)}.`,
    `Precio de mostrador: ${formatMXN(rate.list_price)}.`,
    `Ahorré: ${formatMXN(savings)} MXN.`,
    "",
    `Cotiza tu envío gratis: ${SHARE_URL}`
  ].join("\n");
}

function shareSavings(rate, savings) {
  const text = buildShareText(rate, savings);
  if (navigator.share) {
    navigator.share({ text }).catch(() => {});
  } else {
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  }
}

export default function SavingsBadge({ rate, compact = false }) {
  const savings = computeSavings(rate);
  if (savings <= 0) return null;

  const onShare = (e) => {
    e.stopPropagation();
    e.preventDefault();
    shareSavings(rate, savings);
  };

  if (compact) {
    return (
      <div className="flex items-center justify-end gap-1 mt-0.5">
        <span className="text-[0.6rem] font-bold text-success leading-none whitespace-nowrap">
          −{formatMXN(savings)}
        </span>
        <button
          type="button"
          onClick={onShare}
          title="Compartir ahorro por WhatsApp"
          aria-label="Compartir ahorro por WhatsApp"
          className="touch-icon text-success hover:text-success/80"
        >
          <Share2 className="w-3 h-3" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-1.5 mt-1.5 surface-inset border-success/40 px-2 py-1">
      <span className="text-[0.65rem] font-bold text-success leading-tight">
        ¡Ahorraste {formatMXN(savings)} vs precio de mostrador!
      </span>
      <button
        type="button"
        onClick={onShare}
        title="Compartir ahorro por WhatsApp"
        aria-label="Compartir ahorro por WhatsApp"
        className="touch-icon text-success hover:text-success/80 shrink-0"
      >
        <Share2 className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}